module.exports = __webpack_public_path__ + "static/media/rfzo-logo.f1d8c6f8.png";